



























































































































import { Component, Prop, Vue, Watch, Emit, Mixins } from 'vue-property-decorator';
import { Menu } from '../../core/models';
import { menu, NAME_ROUTES, PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils';
import { RootStoreHelper, AuthStoreHelper } from '../../core/mixins';
import { AuthEvent } from '../../../store';

@Component
export default class Navigation extends Mixins(RootStoreHelper, AuthStoreHelper) {
    @Prop({ default: false }) value: boolean;
    mini: boolean = true;
    homeMenu: Menu = {
        menu: 'Inicio',
        icon: 'home',
        route: NAME_ROUTES.HOME.name
    };
    reempujonListUrl: string = NAME_ROUTES.REEMPUJON_MANAGEMENT_PANEL.path;
    imgUrl: string = require('../../reempujon/reempujon_only_r.png');

    loaded: boolean = false;

    get getGTMClassMap() {
        if (!this.$store.state.userGroupSmartway) {
            return 'ga_btn_navigation_map';
        } else {
            return '';
        }
    }

    get displayMenus(): any {
        return menu;
    }

    get tracking(): string {
        return NAME_ROUTES.TRACKING.path;
    }

    get home(): string {
        return NAME_ROUTES.HOME.path;
    }

    get journeys(): string {
        return NAME_ROUTES.JOURNEYSLIST.path;
    }

    get shouldReadJourneys(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.JOURNEYS, PRIVILEGE_TYPES.READ);
    }

    get shouldConfigure(): boolean {
        return (
            this.$_checkPrivileges(PRIVILEGE_KEYS.SETTINGS, PRIVILEGE_TYPES.READ)
        );
    }
    get shouldCreateAndReadNorms(): boolean {
        return (
            this.$_checkPrivileges(PRIVILEGE_KEYS.NORMS, PRIVILEGE_TYPES.EDIT_AND_DELETE) ||
            this.$_checkPrivileges(PRIVILEGE_KEYS.NORMS, PRIVILEGE_TYPES.CREATE)
        );
    }

    get shouldCreateAndReadInsurances(): boolean {
        return (
            this.$_checkPrivileges(PRIVILEGE_KEYS.INSURANCE, PRIVILEGE_TYPES.EDIT_AND_DELETE) ||
            this.$_checkPrivileges(PRIVILEGE_KEYS.INSURANCE, PRIVILEGE_TYPES.CREATE)
        );
    }

    get reports(): string {
        return NAME_ROUTES.REPORTS.path;
    }

    get shouldReadReports(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.REPORTS, PRIVILEGE_TYPES.READ);
    }

    get settings(): string {
        return NAME_ROUTES.SETTINGS.path;
    }

    get insurance(): string {
        return NAME_ROUTES.INSURANCE.path;
    }

    get norms(): string {
        return NAME_ROUTES.NORMAS.path;
    }

    get shouldSeeReempujon(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.REEMPUJON, PRIVILEGE_TYPES.READ);
    }

    // get shouldReadSettings(): boolean {
    //     return this.$_checkPrivileges(PRIVILEGE_KEYS.SETTINGS, PRIVILEGE_TYPES.READ);
    // }

    unsubscribe: () => void;

    mounted() {
        this.unsubscribe = this.$store.subscribe((mutation, stateList) => {
            if (mutation.type !== AuthEvent.SET_PRIVILEGES) return;
        });
    }

    destroyed() {
        this.unsubscribe();
    }

    @Watch('value')
    onValueChanged(val: boolean): void {
        if (val) {
            this.mini = true;
        }
    }
}
